import React from "react";
import "./Cards.css";
import Modal from "react-modal";
import Highlight from "react-highlight.js";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

export default function FloatingPanel({ code, updateCodeSampleClick }) {
  const [modalIsOpen, setIsOpen] = React.useState(true);

  function closeModal() {
    setIsOpen(false);
    updateCodeSampleClick(false);
  }

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Code Sample"
        style={customStyles}
      >
        {code ? (
          <Highlight language={"javascript"}>
            {code.map((item, index) => (
              <pre key={index}> {item} </pre>
            ))}
          </Highlight>
        ) : (
          ""
        )}
      </Modal>
    </div>
  );
}
